module.exports = __webpack_public_path__ + "img/7.fe7d93fb.jpg";